export function CreatesingleServicePageLink(categoryMenu:any) {
    let serviceObj: any = {};
    if (categoryMenu?.menu?.length === 1){
        serviceObj.serviceLength = categoryMenu?.menu?.length;
        serviceObj.serviceUrl = categoryMenu?.menu[0]?.link;
        serviceObj.name = categoryMenu?.menu[0]?.name;
        return serviceObj;
    }
        return categoryMenu;
    }